<template>
    <div class="con" :class="{'dark':active2}">
        <div class="mm">
            <div class="main">
                <a class="left" href="/home.html">
                    <img class="a" src="../assets/ycb/topLogo.png" alt="">
                </a>
                <div class="right" v-if="!menuOpen2">
                    <div class="item">
                        <a href="https://mall.jd.com/index-620573.html" target="_blank">
                            <img src="../assets/ycb/jd.png" alt="">
                        </a>
                    </div>
                    <div class="item">
                        <a href="https://cihuazhenpin.taobao.com/?spm=2013.1.0.0.12275f8bXnryUx" target="_blank">
                            <img src="../assets/ycb/tb.png" alt="">
                        </a>
                    </div>
                    <div class="lines"  @click="menuOpen2=!menuOpen2">
                       <div class="l">
                           <span></span><span></span><span></span>
                       </div>
                        <div class="r">
                            MENU
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="nav animated fadeInRight" v-if="menuOpen2">
            <div class="close" @click="menuOpen2=false">
             <i class="iconfont icon-guanbi"></i>
            </div>
            <ul>
                <a href="/home.html" :class="page === 'home' ? 'showLine' : ''"> <li >首页
               </li></a>
                <a href="/about.html" :class="page === 'about' ? 'showLine' : ''"><li >慈华臻品
                </li></a>
                <a href="/pro.html" :class="page === 'pro' ? 'showLine' : ''"> <li >产品中心</li></a>
                <a href="/news.html" :class="page === 'news' ? 'showLine' : ''"><li >新闻资讯</li></a>
                <a href="/contact.html" :class="page === 'contact' ? 'showLine' : ''"><li >联系我们</li></a>
            </ul>
            <div class="icons">
                <a href="https://mall.jd.com/index-620573.html" target="_blank">
                    <i class="iconfont icon-jingdong2"></i>
                </a>
                <a href="https://cihuazhenpin.taobao.com/?spm=2013.1.0.0.12275f8bXnryUx" target="_blank">
                    <i class="iconfont icon-taobao"></i>
                </a>
            </div>
        </div>
        <div class="top animated fadeInDown">
            <a href="/index.html" class="l1">
                <img class="a" src="../assets/ycb/topLogo.png" alt="">
            </a>
            <div class="mNav" @click="menuSwitch" :class="{active:menuShow}">
                <span class="burger"></span>
                <span class="burger"></span>
                <span class="burger"></span>
            </div>
        </div>
<!--        <div class="menuBox" :class="{open: menuShow}">-->
<!--            <ul>-->
<!--                <li ><a href="/home.html">首页</a></li>-->
<!--                <li style="transition-delay: 0.2s"><a href="/about.html">关于汇燊</a></li>-->
<!--                <li style="transition-delay: 0.3s"><a href="/pro.html">产品中心</a></li>-->
<!--                <li style="transition-delay: 0.4s"><a href="/news.html">汇燊动态</a></li>-->
<!--                <li style="transition-delay: 0.5s"><a href="/sale.html">技术支持</a></li>-->
<!--                <li style="transition-delay: 0.6s"><a href="/contact.html">联系汇燊</a></li>-->
<!--            </ul>-->
<!--        </div>-->
    </div>
</template>

<script>
    import Scrollbar from 'smooth-scrollbar';
    export default {
        name: "first",
        data(){
            return{
                menuOpen2:false,
                isShowSearch:false,
                menuShow:false,
                keywords:'',
                select:0,
                menuOpen:false,
                active2:false,
                scrollbar:'',
                top:''
            }
        },
        props:['page'],
        // watch: {
        //     $route: 'getScrollbar'
        // },
        mounted(){
            this.$nextTick(()=>{
                this.getScrollbar()
            })
        },
        methods:{
            his(){
                this.isShowSearch=false
            },
            showS(){
                this.isShowSearch=true
            },
            menuSwitch(){
                this.menuShow=!this.menuShow
                this.$emit('menushow',this.menuShow)
            },
            change(n){
                const  link=`/about.html?index=${n}`
                window.open(link,'_self')
            },
            gotoPros(){
                const  link=`/proSearch.html?name=${this.keywords}`
                window.open(link,'_self') // this.project.link
            },
            aStyle(n){
                return {transitionDelay:n*0.1+'s'}
            },
           goto(n){
              const link=`/${n}.html`
               window.open(link,'_self')
           },
            scrollHeader(scrollTop){
                this.active2=scrollTop>200 ? true : false
            },
            getScrollbar(){
                this.$nextTick(()=>{
                    this.scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
                    this.active2=false
                    this.select=parseInt(localStorage.getItem('home.html'))
                    let scrollHeader=this.scrollHeader
                    if(this.scrollbar){
                        this.scrollbar.addListener((status) => {
                            scrollHeader(status.offset.y)
                        });
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .con{
        width:100%;
        position: fixed;
        top:0;
        left:0;
        z-index: 1000;
        transition: all 1s;
        .mm{
            width:100%;
          padding: 20px 0;
            transition: all 600ms;
            .main{
                width:85%;
                display: flex;
                flex-direction: row;
                transition: all 600ms;
                margin: 0 auto;
                align-items: center;
                justify-content: space-between;
                .left{
                    display: inline-block;
                    width:182px;
                    height:67px;
                    position: relative;
                    transition: all 600ms;
                    overflow: hidden;
                    img{
                        position: absolute;
                        left:-100%;
                        top:0;
                        height:100%;
                        width:100%;
                        animation: show 1s linear forwards;
                        opacity: 0;
                        object-fit: contain;
                    }
                    @keyframes show {
                        from{
                            left:-100%;
                            opacity: 0;
                        }
                        to{
                            left:0;
                            opacity: 1;
                        }
                    }
                }
                .right{
                    display:flex;
                     flex-direction: row;
                    align-items: center;
                    .item{
                        margin: 0 20px;
                    }
                    .lines{
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        margin-left: 20px;
                        cursor: pointer;
                        .l{
                            height:30px;
                            width:20px;
                            position: relative;
                            span{
                                display: inline-block;
                                height:1px;
                                width:20px;
                                background-color: white;
                                position: absolute;
                                transition: all 200ms;
                                animation: long 1s infinite linear;
                            }
                            span:nth-child(1){
                                top:5px;
                                left:0;
                            }
                            span:nth-child(2){
                                left:5px;
                                top:12px;
                          animation: none;
                            }
                            span:nth-child(3){
                                left:0;
                                top:19px;
                            animation-delay: 200ms;
                            }
                            @keyframes long {
                              0%{
                                  left:0;
                              }
                                25%{
                                    left:6px;
                                }
                                50%{
                                    left:9px;
                                }
                                75%{
                                    left:6px;
                                }
                                100%{
                                    left:0;
                                }

                            }
                        }
                        .r{
                        font-family: "Fira Code Light";
                            color:white;
                            margin: -5px 0 0 15px;
                        }
                    }
                }
            }
        }
        .nav{
            width:257px;
            background:rgba(247,247,247,.6);
            text-align: center;
            height:100vh;
            transition: all 600ms;
            position: absolute;
            right:0;
            z-index: 1000;
            top:0;
            .close{
                position: absolute;
                left:35px;
                top:40px;
                i{
                    font-size: 25px;
                    color:#595959;
                    cursor: pointer;
                    transition: all 600ms;
                }
            }
            ul{
                list-style: none;
                margin-top: 150px;
                a{
                    li{
                        padding: 20px 0;
                        font-family: "SourceHanSansCN-Light";
                        font-size: 15px;
                        transition: all 600ms;
                        color:#595959;
                        margin-bottom: 30px;
                    }
                    li:hover{
                        background-color:#F7C56B;
                        color:white;
                    }
                }
                .showLine{
                    li{
                        background-color: #F7C56B;
                        color:white;

                    }
                }
            }
            .icons{
                width:100%;
                display: flex;
                flex-direction: row;
                justify-content: center;
                margin: 50px auto;
                a{
                    cursor: pointer;
                    color:#A3A3A3;
                    transition: all 600ms;
                    margin: 0 20px;
                    display: inline-block;
                    i{
                        font-size: 30px;
                    }
                    &:hover{
                        color:#F7C56B;
                    }
                }
            }
        }
        .search{
            position: absolute;
            z-index: 2;
            top: 200px;
            transform:translateY(-800px);
            left: 0;
            transition: all 1s;
            height: 100%;
            width: 100%;
            background: #14151c;
            .form{
                position: relative;
                height: 100%;
                margin: 0 calc(5% + 116px) 0 calc(5% + 170px);
                input{
                    -webkit-font-smoothing: antialiased;
                    visibility: visible;
                    box-sizing: border-box;
                    font-family: "Open Sans", sans-serif;
                    -webkit-appearance: none;
                    border: none;
                    border-radius: 0;
                    width: 100%;
                    color: #ffffff;
                    font-size: 2.4rem;
                    height: 100%;
                    background-color: transparent;
                    padding-right: 170px;
                }
                .goto{
                    position: absolute;
                    right:50px;
                    top:40px;
                    height:40px;
                    width:40px;
                    background-color: #dd85ac;
                    border-radius: 50%;
                    color:white;
                    text-align: center;
                    line-height: 40px;
                    cursor: pointer;
                    transform: scale(0);
                    transition: all 1s;
                    transition-delay: 1s;
                    i{
                        font-size: 25px;
                    }
                }
                .close{
                    position: absolute;
                    right:0;
                    top:45px;
                    height:40px;
                    width:40px;
                    border-radius: 50%;
                    color:white;
                    text-align: center;
                    line-height: 40px;
                    cursor: pointer;
                    transform: scale(0);
                    transition: all 1s;
                    transition-delay:1.5s;
                    i{
                        font-size: 25px;
                    }
                }
            }
               &::before{
                   content:'';
                   display: inline-block;
                   height:190px;
                   width:1px;
                   background-color: white;
                   left:50%;
                   top:-200px;
                   position: absolute;
               }
            &::after{
                content:'';
                display: inline-block;
                height:10px;
                width:10px;
                border-radius: 50%;
                background-color: white;
                left:49.8%;
                top:-10px;
                position: absolute;
            }
        }
        .showSearch{
            transform:translateY(0);
            .form{
                .goto,.close{
                    transform: scale(1);
                }
            }
        }
        .top{
            display: none;
        }
        .menuBox{
            position: fixed;
            top: -100vh;
            left:0;
            height:100vh;
            width: 80%;
            background:#2bad38;
            z-index: 1010;
            transition: .8s;
            display: block;
        }
        .menuBox.open{
            left:0;
            top: 69px;
            padding-top: 20px;
            ul{
                li{
                    transform: matrix(1, 0, 0, 1, 0, 0);
                }
            }
        }
        .menuBox ul{
            display: block;
            font-size: 18px;
            width:100%;
            padding: 18px 0px;
            text-align: center;
            list-style: none;
            li{
                padding: 15px 0;
                text-transform: uppercase;
                font-family: SourceHanSerifCN-Regular;
                transform: matrix(1, 0, 0, 1, -600, 0);
                transition: all 1s;
                a{
                    color:white;
                    transition: all 1s;
                    font-size: 12px;
                }
            }
        }
        @keyframes transition1 {
            0% {
                transform: translate(-100px,-100px);
                opacity: 0;
            }
            100% {
                transform: translate(0,0);
                opacity: 1;
            }
        }
        @keyframes transition2 {
            0% {
                transform: translate(100px,-100px);
                opacity: 0;
            }
            100% {
                transform: translate(0,0);
                opacity: 1;
            }
        }
        @keyframes polygon {
            0% {
                clip-path: polygon(0% 0%, 0% 100%, 0% 100%, 0% 0%);
            }
            100% {
                clip-path: polygon(0% 0%, 0% 100%, 100% 100%, 100% 0%);
            }
        }
        @media screen and (min-width: 2200px){
            .main{
                ul{
                    width:60%;
                }
            }
        }
        @media screen and (max-width: 1440px){
            .mm{
                .main{
                    width:90%;
                    margin-left: 5%;
                    .right{
                        ul{
                            margin-left: 40px;
                        }
                    }
                }
            }
        }
        @media screen and (max-width: 1000px){
            .mm{
                display: none;
            }
            .search{
                display: none;
            }
            .top{
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                width:100%;
                transition: all 2s;
                background-color: rgba(0,0,0,.5);
                a{
                    display: inline-block;
                    padding: 10px 0;
                    width:100%;
                    img{
                        height:50px;
                        margin-left: 10px;
                        object-fit: contain;
                    }
                }
            }
            .mNav{
                display: block;
                transition: .8s;
                position: absolute;
                right: 0;
                top: 0;
                bottom: 0;
                width: 60px;
            }
            .mNav .burger{
                width: 32px;
                height: 3px;
                background-color: white;
                position: absolute;
                top:23px;
                left: 50%;
                margin: 0px 0px 0px -16px;
                transform-origin: center;
                transition: .8s;
            }
            .mNav .burger:nth-of-type(2){
                top:33px;
            }
            .mNav .burger:nth-of-type(3){
                top: 43px;
            }
            .mNav.active{
                /*background-color:#2bad38;*/
            }
            .mNav.active .burger{
                background-color: #CBAE85;
            }
            .mNav.active .burger:nth-of-type(1){
                top: 33px;
                transform: rotate(225deg);
            }
            .mNav.active .burger:nth-of-type(2){
                left: -100%;
                opacity: 0;
            }
            .mNav.active .burger:nth-of-type(3){
                top: 33px;
                transform: rotate(-225deg);
            }
        }
    }
    .dark{
        background-color: rgba(0,0,0,.5);
        transform: translateY(-10px);
        .mm{
            padding-bottom: 10px;
            .main{
                .left{
                    height:50px;
                }
            }
        }
        /*@media screen and (max-width:450px){*/
        /*    .mImg{*/
        /*        display: none;*/
        /*    }*/
        /*    .mImg2{*/
        /*        display: block;*/
        /*    }*/
        /*    .mNav .burger{*/
        /*        background-color: #0C3665;*/
        /*    }*/
        /*}*/
    }
</style>
